import React, { useState } from 'react'
import { useAtom } from 'jotai'
import Classnames from 'classnames'

import axios from 'axios'
import Cookies from 'js-cookie'
import { useRouter } from 'next/router'

// helper functions
import { returnValue } from '@/utils/op-types/helperFunctions'

// store
import {
  isBuilder,
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
  userContents,
} from '@/utils/op-types/store'

// block renderer
import BlockRenderer from '@/components/optypes/frontend/BlockRenderer'
import OnepagerFooter from '@/components/optypes/headlesss-components/OnepagerFooter'

// block builder tools
import StaticContentWrapper from '@/components/optypes/frontend/StaticContentWrapper'
import AddBlockBuilder from '@/components/optypes/frontend/AddBlockBuilder'

// blocks
import Block from '@/components/optypes/frontend/AskCampaign/blocks/Block'

const Components = {
  inputblock: Block,
}

const MainComponentRenderer = ({ id, onepager }) => {
  const [builder] = useAtom(isBuilder)
  // manifest settings
  const [opStatic] = useAtom(manifestStatic)
  const [opDesign] = useAtom(manifestDesign)
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [pageStatic] = useAtom(pageContentStatic)
  const [pageDesign] = useAtom(pageContentDesign)
  const [pageBlocks] = useAtom(pageContentBlocks)

  const [getUserContents, setUserContents] = useAtom(userContents)

  const [email, setEmail] = useState('')
  const [emailError, setEmailError] = useState(false)
  const [signedup, setSignedup] = useState(false)

  const router = useRouter()

  const loginWithMagic = async () => {
    if (validateEmail(email)) {
      // setLoading(true)
      setEmailError(false)

      // set cookie wl-email for subdomain.domain
      Cookies.set('wl-email', email, { expires: 14, path: router.asPath })
      Cookies.set('wl-submissionConsent', true, {
        expires: 14,
        path: router.asPath,
      })

      // setShareContent(false)

      const signUpAndCheckContent = await axios.post(
        '/api/rest/signup-email-and-get-content-type',
        {
          email: email,
          id: id,
          content: JSON.stringify(getUserContents),
          consent: true,
        }
      )

      if (signUpAndCheckContent.data.content) {
        setUserContents(signUpAndCheckContent.data.content)
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname

      window.history.pushState({ path: newurl }, '', newurl)

      // check if integration
      if (onepager.integration?._id) {
        // trigger integration
        try {
          await axios.post(
            AllIntegrations[onepager.integration?.service].pipedream_url,
            {
              integrationId: onepager.integration?._id,
              email: email,
            }
          )
        } catch {
          // don't catch any errors for now...
        }
      }

      // check what action

      if (returnValue('redirecturl', opStatic, pageStatic)) {
        // redirect
        setTimeout(function () {
          window.location.replace(
            returnValue('redirecturl', opStatic, pageStatic)
          )
        }, 500)
      } else {
        // show msg
        setSignedup(true)
      }

      // setLoading(false)
      setEmailError(false)
      // toggleSignUpModal(false)
      // setUserEmail(email)
    } else {
      setEmailError(true)
    }
  }

  function validateEmail(email) {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase())
  }

  function loginOnEnter(e) {
    if (e.key === 'Enter') {
      e.preventDefault()
      loginWithMagic()
    }
  }

  return (
    <div
      className="min-h-screen pt-16 relative"
      style={{
        backgroundColor: returnValue('bgcolor', opDesign, pageDesign),
        color: returnValue('textcolor', opDesign, pageDesign),
      }}
    >
      {/* background image */}
      {returnValue('bgimgurl', opDesign, pageDesign) && (
        <div
          className="absolute top-0 left-0 z-0 h-full w-full  bg-cover bg-no-repeat"
          style={{
            backgroundImage: `url(${returnValue(
              'bgimgurl',
              opDesign,
              pageDesign
            )})`,
            opacity: returnValue('bgimgopacity', opDesign, pageDesign),
          }}
        ></div>
      )}

      <div
        style={{
          backgroundColor: returnValue(
            'containerbgcolor',
            opDesign,
            pageDesign
          ),
        }}
        className={Classnames(
          'container relative z-10 mx-auto shadow-lg rounded overflow-hidden',
          {
            'max-w-4xl':
              returnValue('widthstyle', opDesign, pageDesign) == 'max-w-4xl',
            'max-w-3xl':
              returnValue('widthstyle', opDesign, pageDesign) == 'max-w-3xl',
            'max-w-2xl':
              returnValue('widthstyle', opDesign, pageDesign) == 'max-w-2xl',
          }
        )}
      >
        {/* header image */}

        {returnValue('headerimage', opStatic, pageStatic) && (
          <div
            className={Classnames(' overflow-hidden bg-cover w-full', {
              'bg-center':
                returnValue('headerimageposition', opStatic, pageStatic) ==
                'center',
              'bg-top':
                returnValue('headerimageposition', opStatic, pageStatic) ==
                'top',
              'bg-bottom':
                returnValue('headerimageposition', opStatic, pageStatic) ==
                'bottom',
              'h-36':
                returnValue('headerimagesize', opStatic, pageStatic) ==
                'medium',
              'h-60':
                returnValue('headerimagesize', opStatic, pageStatic) == 'large',
              'h-24':
                returnValue('headerimagesize', opStatic, pageStatic) == 'small',
            })}
            style={{
              backgroundImage: `url(${returnValue(
                'headerimage',
                opStatic,
                pageStatic
              )})`,
            }}
          ></div>
        )}

        {/* content */}

        {!signedup && (
          <>
            <div className="px-12 pt-12">
              <h1
                className={Classnames('font-bold leading-tight text-4xl', {})}
              >
                <StaticContentWrapper contentKey="headline">
                  {returnValue('headline', opStatic, pageStatic)}
                </StaticContentWrapper>
              </h1>
              <div className="mt-2 mx-auto text-xl font-medium">
                <StaticContentWrapper contentKey="subheadline">
                  {returnValue('subheadline', opStatic, pageStatic)}
                </StaticContentWrapper>
              </div>

              {/* rich text */}
              <StaticContentWrapper contentKey="maincopy">
                <div
                  className="mt-4 prose"
                  dangerouslySetInnerHTML={{
                    __html: returnValue('maincopy', opStatic, pageStatic),
                  }}
                >
                  {/*  */}
                </div>
              </StaticContentWrapper>
            </div>

            {/* BLOCKS - example  */}
            <div className="px-12 pt-4 pb-12">
              <div className="space-y-6">
                <div
                  style={{
                    backgroundColor: returnValue(
                      'questionbgcolor',
                      opDesign,
                      pageDesign
                    ),
                  }}
                  className=" shadow-inner p-6 space-y-6 rounded"
                >
                  {pageBlocks.map((block, index) => (
                    <BlockRenderer
                      key={index}
                      index={index}
                      Components={Components}
                      block={block}
                    />
                  ))}

                  {/* add block button builder */}
                  {builder && (
                    <div className="my-8">
                      <AddBlockBuilder btnText="Add Question" />
                    </div>
                  )}

                  <div className="mt-6 flex items-end justify-between  border-t-2 border-black border-opacity-10 pt-6">
                    <div className="flex-grow">
                      <StaticContentWrapper contentKey="emaillabel">
                        <div className="font-medium mb-2">
                          {returnValue('emaillabel', opStatic, pageStatic)}
                        </div>
                      </StaticContentWrapper>
                      <input
                        type="email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        className="w-full text-xl border-2 outline-none focus:ring-transparent rounded shadow-inner py-3 px-4"
                        placeholder={returnValue(
                          'emailplaceholder',
                          opStatic,
                          pageStatic
                        )}
                        style={{
                          backgroundColor: returnValue(
                            'inputbgcolor',
                            opDesign,
                            pageDesign
                          ),
                          borderColor: returnValue(
                            'inputbordercolor',
                            opDesign,
                            pageDesign
                          ),
                          color: returnValue(
                            'inputtextcolor',
                            opDesign,
                            pageDesign
                          ),
                        }}
                      />
                    </div>
                    <div className="flex-shrink-0 ml-8">
                      <button
                        onClick={() => {
                          if (!builder) {
                            // toggleSignUpModal(true)
                            loginWithMagic()
                          }
                        }}
                        style={{
                          backgroundColor: returnValue(
                            'signupbtnbg',
                            opDesign,
                            pageDesign
                          ),
                          color: returnValue(
                            'signupbtntext',
                            opDesign,
                            pageDesign
                          ),
                        }}
                        className="mb-1 text-xl inline-block cursor-pointer hover:shadow-md py-3 px-6 rounded  font-bold"
                      >
                        {returnValue('signupbtn', opStatic, pageStatic)}
                      </button>
                    </div>
                  </div>

                  {emailError && (
                    <div className="mt-4">
                      ** Issue with email - try again...
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}

        {/* thank you msg */}
        {signedup && (
          <div
            className="p-24 prose"
            dangerouslySetInnerHTML={{
              __html: returnValue('thankyoucopy', opStatic, pageStatic),
            }}
          ></div>
        )}
      </div>

      {/* footer */}
      <div className="py-8">
        <OnepagerFooter />
      </div>
    </div>
  )
}

export default MainComponentRenderer
